import React, { useState, useEffect } from 'react';
import Header from '../layouts/CaseBuilder/components/Header/Header';
import CaseBuilder from '../layouts/CaseBuilder/CaseBuilder';

const CaseBuilderPage = ({ brandTag }) => {
	return (
		<>
			<Header brandTag={brandTag} />
			<CaseBuilder />
		</>
	);
};

export default CaseBuilderPage;
